var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.47 6.47 2 12 2C17.53 2 22 6.47 22 12C22 17.53 17.53 22 12 22C6.47 22 2 17.53 2 12ZM14.8902 16.2997C15.2802 16.6897 15.9102 16.6897 16.3002 16.2997C16.6802 15.9097 16.6802 15.2697 16.3002 14.8897L13.4102 11.9997L16.3002 9.10973C16.6902 8.71973 16.6902 8.08973 16.3002 7.69973C15.9102 7.30973 15.2802 7.30973 14.8902 7.69973L12.0002 10.5897L9.1102 7.69973C8.7202 7.30973 8.0902 7.30973 7.7002 7.69973C7.51295 7.88656 7.40771 8.14021 7.40771 8.40473C7.40771 8.66924 7.51295 8.92289 7.7002 9.10973L10.5902 11.9997L7.7002 14.8897C7.51295 15.0766 7.40771 15.3302 7.40771 15.5947C7.40771 15.8592 7.51295 16.1129 7.7002 16.2997C8.0902 16.6897 8.7202 16.6897 9.1102 16.2997L12.0002 13.4097L14.8902 16.2997Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.b7ac2fc4cc176d0b6c9cccc969f37004.svg";
export { ForwardRef as ReactComponent };